import ProcessMapView from '@Client/runner.processmapsv2/components/View/ProcessMapView';
import { Guid } from '@Shared.Angular/@types/guid';
import React from 'react';

type Props = {
  processMapId: Guid;
  hideFeedBack: boolean;
};
const PublicMap = (props: Props) => {
  return (
    <ProcessMapView
      hideFeedBack={true}
      isPublicMapView={true}
      processMapId={props.processMapId}
    ></ProcessMapView>
  );
};

export default PublicMap;
